/**
 * RTL Support JavaScript Helper
 * Provides RTL-aware scrolling and positioning utilities
 */

(function() {
  'use strict';

  // Check if document is RTL
  const isRTL = () => {
    return document.documentElement.getAttribute('dir') === 'rtl';
  };

  // RTL-aware scrollTo helper
  const scrollToPosition = (element, position) => {
    if (!element) return;
    
    if (isRTL()) {
      // For RTL, we need to invert the scroll position
      // Different browsers handle RTL scrolling differently
      const scrollWidth = element.scrollWidth;
      const clientWidth = element.clientWidth;
      const maxScroll = scrollWidth - clientWidth;
      
      // Invert position for RTL
      element.scrollTo({ 
        left: maxScroll - position,
        behavior: 'smooth'
      });
    } else {
      element.scrollTo({ 
        left: position,
        behavior: 'smooth'
      });
    }
  };

  // RTL-aware offsetLeft calculation
  const getOffsetLeft = (element) => {
    if (!element) return 0;
    
    if (isRTL()) {
      const parent = element.parentElement;
      if (!parent) return element.offsetLeft;
      
      // Calculate RTL offset
      return parent.offsetWidth - element.offsetLeft - element.offsetWidth;
    }
    
    return element.offsetLeft;
  };

  // RTL-aware scroll position getter
  const getScrollPosition = (element) => {
    if (!element) return 0;
    
    if (isRTL()) {
      const scrollWidth = element.scrollWidth;
      const clientWidth = element.clientWidth;
      const maxScroll = scrollWidth - clientWidth;
      
      // Different browsers report RTL scrollLeft differently
      const scrollLeft = element.scrollLeft;
      
      // Normalize: if scrollLeft is negative (Firefox), convert to positive
      if (scrollLeft < 0) {
        return Math.abs(scrollLeft);
      }
      
      // If scrollLeft is positive but counting from right (Safari/Edge)
      if (scrollLeft > 0 && scrollLeft < maxScroll) {
        return maxScroll - scrollLeft;
      }
      
      return scrollLeft;
    }
    
    return element.scrollLeft;
  };

  // Expose utilities globally
  window.RTLSupport = {
    isRTL,
    scrollToPosition,
    getOffsetLeft,
    getScrollPosition
  };

  // Monkey-patch existing scroll functions if they exist
  if (window.Shopify && window.Shopify.designMode) {
    console.log('RTL Support loaded for Shopify theme');
  }

})();
